<template>
  <div class="eventContainer">
    <b-modal ref="modal" centered hide-footer>
      <slot name="modal-header">
        <h2 class="text-center mt-4">Modification</h2>
      </slot>
      <slot name="defalt">
        <div class="quantityModal">
          <h2 class="text-xl text-center mt-4">
            {{ currentProduct.product }} X
            {{ currentProduct.canceled ? 0 : currentProduct.quantity }}
          </h2>
          <div class="p-8 pt-6">
            <div class="flex items-center">
              <p class="text-lg font-medium" style="margin-right: 60px">
                Modifier la date
              </p>
              <datepicker :language="fr" v-model="modalData.date"></datepicker>
            </div>
            <div class="flex items-center my-4">
              <p class="text-lg mr-4 font-medium">Modifier la quantité</p>
              <input type="number" v-model="modalData.quantity" />
            </div>
            <div v-if="currentProduct.possibleFactorisations && currentProduct.commandFactorisation" class="flex items-center justify-center flex-column my-4">
              <p class="text-lg font-medium">Modifier la factorisation</p>
              <div v-for="item in currentProduct.possibleFactorisations" v-bind:key="item + 'kg'" class="flex flex-row">
                <input min="0" @change="() => verifyFactorisationValue(item)" type="number" v-model="modalData.factorisation[item]" style="width: 60px; margin-right: 10px" />
                <p class="text-lg font-medium">x {{ item }}kg</p>
              </div>
            </div>
            <p v-if="parseInt(modalData.quantity) === 0 && !currentProduct.canBeCanceled" class="text-center text-red bold">
              Vous ne pouvez pas annuler ce produit, rendez-vous sur le chat pour plus d'informations.
            </p>
            <button v-if="!(parseInt(modalData.quantity) === 0 && !currentProduct.canBeCanceled)" @click="update(event)">VALIDER</button>
          </div>
        </div>
      </slot>
    </b-modal>

    <b-modal ref="modalBadAmount" centered hide-footer size="300px">
      <div class="quantityModal">
        <h2 class="text-center mt-4">Attention</h2>
        <p class="text-lg p-4 text-center">
          <span class="text-lg font-bold"
            >Pour être livrée gratuitement, la commande doit être de 50 euros
            minimum.</span
          >
          <br />
          C’est pourquoi vos modifications de quantité ne peuvent pas être
          prises en compte.
          <br />
          Pour plus d’informations, rendez-vous sur le chat !
        </p>
        <button @click="closeBadAmountModal" class="mb-4">RETOUR</button>
      </div>
    </b-modal>

    <b-modal ref="minimalQuantity" centered hide-footer size="300px">
      <div class="quantityModal">
        <h2 class="text-center mt-4">Attention</h2>
        <p class="text-lg p-4 text-center">
          <span class="text-lg font-bold">
           Vous avez atteint la quantité minimale de ce produit.
            <br> Quantité minimale : {{ minimalQuantity }}
          </span>
        </p>
        <button @click="minimalQuantityAction" class="mb-4">RETOUR</button>
      </div>
    </b-modal>

    <b-modal centered ref="modalBadDate" size="300px" hide-footer>
      <div class="quantityModal">
        <h2 class="text-center mt-4">Attention</h2>
        <p class="text-lg p-4 text-center">
            La modification de votre commande est trop tardive.<br />
            Celle-ci doit se faire au plus tard l'avant-veille à 10h (hors vendredi).<br />
            Rendez-vous sur le chat !
        </p>
        <button @click="closeBadDate" class="mb-4">RETOUR</button>
      </div>
    </b-modal>

    <b-modal centered ref="validation-modal" size="300px" hide-footer>
      <div class="quantityModal">
        <h2 class="text-center mt-4">Merci</h2>
        <p class="text-lg p-4 text-center">
          Votre demande a bien été prise en compte !
        </p>
      </div>
    </b-modal>

    <b-modal ref="modalCommandsForDate" centered hide-footer>
      <slot name="modal-header">
        <h2 class="text-center mt-4">Modification</h2>
      </slot>
      <slot name="defalt">
        <div class="quantityModal">
          <h2
            v-for="command in editableCommandsColumn"
            v-bind:key="command.id"
            class="text-xl text-center mt-4"
          >
            {{ command.product }} X
            {{ command.canceled ? 0 : command.quantity }}
          </h2>
          <div class="p-8 pt-6">
            <div class="flex items-center my-4">
              <p class="text-lg font-medium" style="margin-right: 60px">
                Modifier la date
              </p>
              <datepicker
                :language="fr"
                v-model="modalDataAllCommands.date"
              ></datepicker>
            </div>
            <button @click="updateCommandsForDate">
              VALIDER
            </button>

            <p v-if="editableCommandsColumn.findIndex((item) => !item.canBeCanceled) !== -1" class="mt-4 text-center text-red bold">
              Le produit "{{ editableCommandsColumn.find((item) => !item.canBeCanceled).product }}" ne peut pas être annulé, rendez-vous sur le chat pour plus d'informations.
            </p>

            <button @click="deleteCommandsForDate" class="button-secondary" v-if="editableCommandsColumn.findIndex((item) => !item.canBeCanceled) === -1">
              SUPPRIMER LA COMMANDE
            </button>
          </div>
        </div>
      </slot>
    </b-modal>

    <b-modal centered ref="modalInvalidFactorisation" size="300px" hide-footer>
      <div class="quantityModal">
        <h2 class="text-center mt-4">Attention</h2>
        <p class="text-lg p-4 text-center">
          La factorisation de votre commande est invalide
        </p>
        <button @click="closeInvalidFactorisationModal" class="mb-4">RETOUR</button>
      </div>
    </b-modal>

    <b-modal centered ref="modalInvalidTotalFactorisation" size="300px" hide-footer>
      <div class="quantityModal">
        <h2 class="text-center mt-4">Attention</h2>
        <p class="text-lg p-4 text-center">
          La quantité et le total de la factorisation de votre commande ne correspondent pas
        </p>
        <button @click="closeInvalidTotalFactorisationModal" class="mb-4">RETOUR</button>
      </div>
    </b-modal>

    <b-modal centered ref="modalNegativeFactorisation" size="300px" hide-footer>
      <div class="quantityModal">
        <h2 class="text-center mt-4">Attention</h2>
        <p class="text-lg p-4 text-center">
          Votre factorisation contient une quantité négative
        </p>
        <button @click="closeNegativeFactorisationModal" class="mb-4">RETOUR</button>
      </div>
    </b-modal>

    <b-modal centered id="modalBreakInformation" ref="modalBreakInformation" size="300px" hide-footer>
      <div class="quantityModal">
        <p v-if="modalDataBreak.start !== modalDataBreak.end">
          La commande livrée à l'adresse <strong>{{ modalDataBreak.address }}</strong> est en pause du <strong>{{ modalDataBreak.start }}</strong> au <strong>{{ modalDataBreak.end }}</strong>
        </p>
        <p v-else>
          La commande livrée à l'adresse <strong>{{ modalDataBreak.address }}</strong> est en pause le <strong>{{ modalDataBreak.start }}</strong>
        </p>
        <button @click="closeBreakInformationModal" class="mb-4">RETOUR</button>
      </div>
    </b-modal>

    <div v-if="isBreakType">
      <div class="breakEvent" @click="showBreakInformationModal(formatDate(dateColumn), formatDate(dateEnd, 'YYYY-MM-DDThh:mm:ss'), address)">
        <div class="productContainer">
          <p class="heading"><strong>En pause</strong> - <span class="font-italic">{{ address }}</span></p>
        </div>
      </div>
    </div>

      <div v-else-if="isDeliclosedType">
          <div class="deliclosedEvent">
              <div class="productContainer">
                  <p class="heading"><strong>Fermeture</strong> - <span class="font-italic">jeux olympiques</span></p>
              </div>
          </div>
      </div>

    <div v-else>
      <DeliveriesImg v-bind="img" />
      <div v-if="displayProduct" class="topEvent">
        <div style="display: flex">
          <!--        if didn't use get time -> a click on any label would check the input of the 1st day  -->
          <label
              style="margin: auto"
              v-bind:for="'checkbox' + dateColumn.getTime()"
          >Tout sélectionner</label
        >
        <input
          style="margin: auto auto auto 0"
          type="checkbox"
          v-bind:id="'checkbox' + dateColumn.getTime()"
          v-model="selectForDate"
        />
      </div>

      <button
        v-if="selectForDate && hasEditableCommands"
        class="btnGreen1"
        @click="showCommandsForDate()"
      >
        MODIFIER
      </button>
    </div>

      <div v-for="cat of categories" :key="cat" style="width: 100%">
        <div
            v-if="event[cat].length"
            :style="displayProduct ? 'margin-bottom : 24px' : ''"
            class="categoryContainer"
        >
          <p :style="'background: ' + colorHeader(cat) + ';'" class="heading">
            {{ catString(cat) }}
          </p>
          <div v-if="displayProduct" class="productContainer">
            <div
                v-for="(el, i) of event[cat]"
                :id="'popover' + 'support' + el.commandID"
                :key="i"
                :class="el.canceled ? 'eventCancel' : undefined"
                class="productLine flex justify-between"
                @click="show(el)"
            >
              <p :class="getPadding(i, event[cat])" class="product">
                {{ el.product }} ({{ el.unit }})
              </p>
              <p :class="getPadding(i, event[cat])" class="quantity">
                x{{ el.canceled ? "0" : el.quantity }}
              </p>
              <b-popover
                  :target="'popover' + 'support' + el.commandID"
                  placement="right"
                  triggers="hover"
              >
                {{ el.address }}
              </b-popover>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "@/Services/api.common.service";
import { CATEGORIES } from "@/setup.const";
import { getCatColor, getCatName } from "@/views/Commands/command.functions";
import moment from "moment";
import datepicker from "vuejs-datepicker";
import { fr } from "vuejs-datepicker/dist/locale";
import "./style.scss";
import DeliveriesImg from "@/views/Commands/deliveriesImg";

export default {
  name: "Event",
  props: {
    arg: { type: Object },
    refetchFunction: {type: Function},
  },
  components: { DeliveriesImg, datepicker },
  mounted() {
    //console.log(this.arg)
  },
  data() {
    return {
      minimalQuantity: undefined,
      fr,
      displayProduct: this.arg.view.type !== "dayGridMonth",
      currentProduct: {},
      modalData: {
        date: new Date(),
        quantity: 0,
        factorisation: {},
      },
      modalDataAllCommands: {
        date: new Date(),
      },
      modalDataBreak: {
        start: null,
        end: null,
        address: null,
      },
      selectForDate: false,
    };
  },
  computed: {
    event() {
      return this.arg.event._def.extendedProps.events;
    },
    img() {
      return this.arg.event._def.extendedProps.img;
    },
    categories() {
      return CATEGORIES.map((e) => e.id);
    },
    isBreakType() {
      return this.arg.event._def.extendedProps.type === 'break';
    },
    isDeliclosedType() {
      return this.arg.event._def.extendedProps.type === 'deliclosed';
    },
    dateColumn() {
      return this.arg.event._instance.range.start;
    },
    dateEnd() {
      return this.arg.event._def.extendedProps.dateEnd;
    },
    address() {
      return this.arg.event._def.extendedProps.address;
    },
    editableCommandsColumn() {
      const commands = [];
      for (const key in this.event) {
        for (const key2 in this.event[key]) {
          if (this.event[key][key2].is_rental) {
            // ignore rentals because cannot be modified
            continue;
          }
          commands.push(this.event[key][key2]);
        }
      }
      return commands;
    },
    hasEditableCommands() {
      return this.editableCommandsColumn.length > 0;
    },
  },
  watch: {
    arg: function (newQuestion) {
      this.displayProduct = newQuestion.view.type !== "dayGridMonth";
    },
  },
  methods: {
    totalPrice(commandsOfDay, currentProduct, newQuantity) {
      return Object.values(commandsOfDay).reduce((total, commands) => {
        commands.forEach(product => {
          if (product === currentProduct) {
            const unitPrice = product.price / product.quantity;
            total += unitPrice * newQuantity;
          } else {
            total += product.price
          }
        });
        return total;
      }, 0);
    },
    showNegativeFactorisationModal() {
      this.$refs["modalNegativeFactorisation"].show();
    },
    closeNegativeFactorisationModal() {
      this.$refs["modalNegativeFactorisation"].hide();
    },
    verifyFactorisationValue(key) {
      if (this.modalData.factorisation[key] < 0) {
        this.modalData.factorisation[key] = 0;
      }
    },
    showInvalidTotalFactorisationModal() {
      this.$refs["modalInvalidTotalFactorisation"].show();
    },
    closeInvalidTotalFactorisationModal() {
      this.$refs["modalInvalidTotalFactorisation"].hide();
    },
    showInvalidFactorisationModal() {
      this.$refs["modalInvalidFactorisation"].show();
    },
    closeInvalidFactorisationModal() {
      this.$refs["modalInvalidFactorisation"].hide();
    },
    hide() {
      this.$refs["modal"].hide();
    },
    show(current) {
      if (current.is_rental) {
        // we can only modify commands that are not `rentals`
        return;
      }
      this.currentProduct = current;
      this.modalData.quantity = current.canceled ? 0 : current.quantity;
      this.modalData.date = new Date(current.date);
      this.modalData.factorisation = current.commandFactorisation;
      this.$refs["modal"].show();
    },
    showBadAmountModal() {
      this.$refs["modalBadAmount"].show();
    },
    showBadDate() {
      this.$refs["modalBadDate"].show();
    },
    closeBadDate() {
      this.$refs["modalBadDate"].hide();
    },
    closeBadAmountModal() {
      this.$refs["modalBadAmount"].hide();
    },
    showValidationModal() {
      this.$refs["validation-modal"].show();
    },
    showCommandsForDate() {
      this.modalDataAllCommands.date = new Date(this.dateColumn);
      this.$refs["modalCommandsForDate"].show();
    },
    closeBreakInformationModal() {
      this.$refs["modalBreakInformation"].hide();
    },
    showBreakInformationModal(startDate, endDate, address) {
      this.modalDataBreak.start = startDate;
      this.modalDataBreak.end = endDate;
      this.modalDataBreak.address = address;

      this.$refs["modalBreakInformation"].show();
    },
    minimalQuantityAction(action) {
      if (action === 'show')
        this.$refs["minimalQuantity"].show();
      else
        this.$refs["minimalQuantity"].hide();
    },
    async update(commandsOfDay) {
      if (this.totalPrice(commandsOfDay, this.currentProduct, this.modalData.quantity) < 50) {
        return this.showBadAmountModal();
      }

      try {
        this.minimalQuantity = undefined

        const data = {
          quantity: this.modalData.quantity,
          date: moment(this.modalData.date).format("yyyy-MM-DD"),
          factorisation: JSON.stringify(this.modalData.factorisation),
        };
        const res = await api().put(
          `commands/${this.currentProduct.commandID}`,
          data
        );

        this.currentProduct.quantity = res.data?.command?.quantity;
        this.currentProduct.date = new Date(res.data?.command?.date);
        this.hide();
        this.showValidationModal();
        this.refetchFunction();
      } catch (e) {
        const type = e?.response?.data?.error?.type;

        if (type === "command_modification_too_late") {
          this.showBadDate();
        }
        if (type === "total_price_too_low") {
          this.showBadAmountModal();
        }
        if (type === "invalid_factorisation") {
          this.showInvalidFactorisationModal();
        }
        if (type === "invalid_total_factorisation") {
          this.showInvalidTotalFactorisationModal();
        }
        if (type === "negative_factorisation") {
          this.showNegativeFactorisationModal();
        }
      }
    },
    updateCommandsForDate: async function () {
      try {
        const data = {
          oldDate: moment(this.dateColumn).format("yyyy-MM-DD"),
          newDate: moment(this.modalDataAllCommands.date).format("yyyy-MM-DD"),
        };
        await api().patch(`commands/onDate`, data);

        this.hide();
        this.showValidationModal();
        this.refetchFunction();
      } catch (e) {
        const type = e?.response?.data?.error?.type;

        if (type === "command_modification_too_late") {
          this.showBadDate();
        }
      }
    },
    deleteCommandsForDate: async function () {
      try {
        const data = {
          date: moment(this.dateColumn).format("yyyy-MM-DD"),
        };
        await api().delete(`commands/onDate`, { data });
        this.hide();
        this.showValidationModal();
        this.refetchFunction();
      } catch (e) {
        const type = e?.response?.data?.error?.type;

        if (type === "command_modification_too_late") {
          this.showBadDate();
        }
      }
    },
    getPadding(index, array) {
      let ret = "";
      if (index === 0) {
        ret += "first";
      }
      if (index === array.length - 1) {
        ret += " last";
      }
      return ret;
    },
    colorHeader(id) {
      return getCatColor(id);
    },
    catString(id) {
      return getCatName(id);
    },
    formatDate(date, inputFormat = null, format = 'DD-MM-YYYY') {
      return moment(date, inputFormat).format(format);
    },
  },
};
</script>

<style lang="scss">
.eventCancel {
  background: antiquewhite !important;

  & * {
    background: antiquewhite !important;
  }
}

.topEvent {
  height: 45px;
  width: 100%;
  text-align: center;
  position: relative;
}

.eventContainer {
  width: 100%;
}

.categoryContainer {
  border-bottom: solid 1px var(--fc-border-color, #ddd);
}

.heading {
  color: white;
  font-size: 16px;
  font-weight: 600;
  line-height: 32px;
  padding-left: 8px;
}

.productLine {
  display: flex;
  cursor: pointer;

  &:hover {
    background: #ebe6e6;
  }
}

.product {
  font-size: 13px;
  margin-left: 6px;
  margin-right: 6px;
  white-space: pre-wrap;
  padding: 4px 0;
  display: inline-flex;
  align-items: center;

  &Container {
    padding: 4px 0;
  }
}

.quantity {
  background: #ebe6e6;
  color: black !important;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 900;
  text-align: left;
  vertical-align: middle;
  width: 25%;
  padding: 4px;
  padding-left: 8px;
  display: inline-flex;
  align-items: center;

  &.first {
    //padding-top : 8px;
  }

  &.last {
    //padding-bottom : 8px;
  }
}

.button-secondary {
  background: transparent !important;
  color: var(--main-green) !important;
  margin-top: 24px !important;
}

.breakEvent {
  cursor: pointer;

  p {
    white-space: pre-wrap;
  }

  &:hover {
    strong, span {
      color: #4c4c4c;
    }
  }

  strong, span {
    color: white;
  }
}

.deliclosedEvent {
    cursor: none;

    p {
        white-space: pre-wrap;
    }

    strong, span {
        color: white;
    }
}

.fc-daygrid-event:hover {
  .breakEvent {
    p {
      color: black;
    }
  }
}

#modalBreakInformation {
  p {
    padding-left: 8px;
    margin: 10px 0;
    text-align: center;
  }
}

</style>
